import {
  Input,
  Output,
  Component,
  OnDestroy,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';

import { SnTag } from '@lib/api/entities';
import { SnCollection } from '@lib/common/models';

@Component({
  selector: 'sn-tag-view-list',
  templateUrl: './tag-view-list.component.html',
  styleUrls: ['./tag-view-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnTagViewListComponent implements OnDestroy {
  @Input()
  get tags(): SnCollection<SnTag> {
    return this._tags;
  }
  set tags(value: SnCollection<SnTag>) {
    this._tags = value;

    this.selectedTags =
      this._tags.length > this.tagsLimit ? this._tags.slice(0, this.tagsLimit) : this._tags;
  }

  @Input()
  public tagsLimit = 3;

  @Output()
  public readonly tagSelected = new EventEmitter<SnTag>();

  public selectedTags: SnTag[];

  private _tags: SnCollection<SnTag>;

  constructor() {}

  public ngOnDestroy(): void {
    this.tagSelected.complete();
  }

  public trackTag(index: number, item: SnTag): any {
    return item.id;
  }

  public selectTag(tag: SnTag): void {
    this.tagSelected.emit(tag);
  }
}
